import { v as bvVar } from 'bv';

export default () => ({
  handler: 'absoluteUrl',
  data: () => `mailto:${bvVar('helpEmail')}`,
});
